module.exports = __webpack_public_path__ + "static/media/PopularCafeNF.56e03d9f.woff";